import axios from "axios";
import {
    detailServicesPath,
} from "../../../../Constants";

export const warehouseFinishedDetailRestUrl = detailServicesPath + '/organization/detail-warehouse'
export default class WarehouseFinishedDetailService {

    static async getAll() {
        return axios.get(warehouseFinishedDetailRestUrl);
    }

    static async get(warehouseId) {
        return axios.get(warehouseFinishedDetailRestUrl + "/" + warehouseId);
    }

    static async save(data) {
        return await axios.post(warehouseFinishedDetailRestUrl, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
}